export const MATURITY_THRESHOLDS = { 1:55, 2:70, 3:80, 4:90 };

export function getMaturityLevel(score, T) {
  if (score >= 90) return { n:5, t:"Leading", c:T.green, bg:"rgba(83,196,109,.15)", tc:"#d9ffe2", d:"Best-practice posture, low risk" };
  if (score >= 80) return { n:4, t:"Excelling", c:T.green, bg:"rgba(83,196,109,.15)", tc:"#d9ffe2", d:"Strong controls across core areas" };
  if (score >= 70) return { n:3, t:"Advancing", c:T.yellow, bg:"rgba(243,181,63,.15)", tc:"#fff1cb", d:"Solid controls, refining the details" };
  if (score >= 55) return { n:2, t:"Developing", c:T.orange, bg:"rgba(255,122,69,.15)", tc:"#ffe0d4", d:"Basic protections in place, key gaps remain" };
  return { n:1, t:"Emerging", c:T.red, bg:"rgba(225,77,87,.15)", tc:"#ffd8db", d:"Core protections still forming — significant gaps to prioritize" };
}

export function maturityGap(score, T) {
  const level = getMaturityLevel(score, T);
  if (level.n >= 5) return "Top tier — best-practice posture";
  const points = Math.max(1, Math.ceil(MATURITY_THRESHOLDS[level.n] - score));
  return `${points} percentage point${points === 1 ? "" : "s"} to ${getMaturityLevel(MATURITY_THRESHOLDS[level.n], T).t}`;
}
